import { Highlight } from './Highlight';

// TODO: in v9, move styled() from Highlight.jsx to here
export var StyledHighlight = Highlight;